<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">{{ cuerpoTecnico ? 'Ficha de Cuerpo Técnico' : 'Ficha de Jugador'  }}</v-toolbar-title>
    </v-toolbar>
    <div v-if="loading" class="spacing-top">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
      <v-card>
        <v-layout row wrap>
          <v-flex xs3 md2 pt-4 pl-2 ml-2 pb-4>
            <v-btn class="photo-button" @click="openFileDirectory" :disabled="!canEditPhoto || loadingPhoto" title="Cambiar imagen">
              <v-img :src="personal.photo" max-height="150px" contain v-if="personal.photo"></v-img>
              <div class="text-xs-center pt-2" v-if="!personal.photo">
                <v-icon color="grey" large>account_box</v-icon>
              </div>
              <AttachFile ref="fileInput" @upload="editPhoto" photo singleFile class="photo-button pa-1" v-show="files.length"></AttachFile>
            </v-btn>
          </v-flex>
          <v-flex xs8 md7>
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ personal.firstName }} {{ personal.lastName }}</div>
                <v-divider class="my-2"></v-divider>
                <div><b>Club:</b> {{ personal.club.nombre }}</div>
                <div><b>Estado:</b> {{ personal.status }}</div>
                <div><b>Nacionalidad:</b> {{ personal.country.name }}</div>
                <div><b>DNI:</b> {{ personal.dni || '-' }}</div>
                <div v-if="personal.pasaporte"><b>Pasaporte:</b> {{ personal.pasaporte }}</div>
                <div><b>Fecha de nacimiento:</b> {{ personal.dateOfBirth }}</div>
                <div v-if="cuerpoTecnico"><b>Rol:</b> {{ personal.rolDisplay }}</div>

              </div>
            </v-card-title>
          </v-flex>
          <v-flex xs3 md2 class="pt-4" v-if="$store.getters.isClubRole">
            <v-btn :disabled="!canEditPersonal" @click="editPersonal" color="primary"
              class="personal-button mb-2">{{cuerpoTecnico ? "Editar Cuerpo Técnico": "Editar Jugador"}}</v-btn>
            <v-btn v-if="canCreateContract" @click="createContract" color="primary" class="personal-button">Agregar contrato</v-btn>
          </v-flex>
          <v-flex xs3 md2 class="pt-4" v-else>
            <v-btn v-if="canAddCondition" @click="createSalaryCondition" color="primary" class="condition-button">Crear condición salarial</v-btn>
          </v-flex>

        </v-layout>
      </v-card>
      <div class="custom-font-light large-text custom-blue-text mb-1 mt-5">
        <v-icon color="grey" large>gavel</v-icon>
        <span v-if="cuerpoTecnico">Contratos del miembro del Cuerpo Técnico</span>
        <span v-else>Contratos del Jugador</span>
      </div>
      <v-divider></v-divider>
      <ContractsTable :personal="personal"></ContractsTable>
      <div v-if="canViewCondition">
        <div class="custom-font-light large-text custom-blue-text mb-1 mt-5">
          <v-icon color="grey" large>request_quote</v-icon>
          <span v-if="cuerpoTecnico">Condiciones salariales del miembro del Cuerpo Técnico</span>
          <span v-else>Condiciones salariales del Jugador</span>
        </div>
        <v-divider></v-divider>
        <SalaryConditionsTable :personal="personal"></SalaryConditionsTable>
      </div>
      <v-btn @click="volverAlListado">Volver</v-btn>
    </div>
  </div>
</template>

<script>
import ContractsTable from '../components/ContractsTable'
import SalaryConditionsTable from '../components/SalaryConditionsTable'
import AttachFile from '../../../common/ui/AttachFile'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { validationMixin } from 'vuelidate'

export default {
  mixins: [validationMixin, createEntityMixin],

  components: {
    ContractsTable,
    SalaryConditionsTable,
    AttachFile
  },

  validations: {
  },

  props: {
    cuerpoTecnico: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      loadingPhoto: false,
      personal: {},
      path: `${this.cuerpoTecnico ? 'cuerpo-tecnico' : 'player'}/${this.$route.params.id}/${this.$route.params.idClub}`
    }
  },

  computed: {
    isEditing () {
      return this.canEditPhoto
    },
    canEditPersonal () {
      return this.$store.state.permissions.canAddJugadores && this.personal.canEdit
    },
    canEditPhoto () {
      return this.$store.state.permissions.canAddJugadores && this.$store.getters.isClubRole
    },
    canCreateContract () {
      return this.$store.state.permissions.canAddContratos
    },
    canAddCondition () {
      return this.$store.state.permissions.canAddConditions && this.$store.getters.isSafRole
    },
    canViewCondition () {
      return this.$store.state.permissions.canViewConditions && this.$store.getters.isSafRole
    }
  },

  methods: {
    fetchData () {
      this.loading = true
      this.axios
        .get(this.path)
        .then(response => {
          this.personal = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    editPersonal () {
      const routeName = this.cuerpoTecnico ? 'editarCuerpoTecnico' : 'editarJugador'
      this.$router.push({ name: routeName, params: { id: this.personal.pk, idClub: this.$route.params.idClub } })
    },
    volverAlListado () {
      const routeName = this.cuerpoTecnico ? 'cuerpoTecnico' : 'jugadores'
      this.$router.push({ name: routeName })
    },
    createContract () {
      this.$router.push({ name: 'nuevoContrato', params: { id: this.personal.pk } })
    },
    createSalaryCondition () {
      this.$router.push({ name: 'nuevaCondicionSalarial', params: { personalId: this.personal.pk, clubId: this.$route.params.idClub } })
    },
    editPhoto (signal) {
      this.uploadFiles(signal)
      let payload = new FormData()
      payload.append('photo', this.files[0], this.files[0].name)
      this.loading = true
      this.loadingPhoto = true
      this.axios
        .put(`player/new-photo/${this.$route.params.id}/${this.$route.params.idClub}`, payload)
        .then(response => {
          this.personal.photo = response.data.photo
          this.loading = false
          this.loadingPhoto = false
          this.files = []
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loading = false
          this.loadingPhoto = false
          this.files = []
        })
    }
  },

  created () {
    this.fetchData()
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
.large-text {
  font-size: 1.8em;
}
.custom-blue-text {
  color: #293968;
}
.personal-button {
  width: 170px;
}
.condition-button {
  width: 240px;
}
.photo-button {
  width: 100%;
  height: 100%;
  max-height: 275px;
}
</style>
